import type { WalletBookSchema } from '../../legacyWalletBook.types';
import type {
  WalletConnectCatalog,
  WalletConnectCatalogGroup,
  WalletConnectCatalogWallet,
} from '../getWalletConnectCatalog.types';
import { shouldFilterWallet } from '../shouldFilterWallet';
import { transformGroup } from '../transformGroup';
import { transformWallet } from '../transformWallet';

type TransformWalletBookParams = {
  walletBook: WalletBookSchema;
};

/**
 * Transforms the legacy wallet book into a WalletConnect catalog structure.
 * Filters out embedded wallets and injected-only wallets.
 */
export const transformWalletBook = ({
  walletBook,
}: TransformWalletBookParams): WalletConnectCatalog => {
  const groups: Record<string, WalletConnectCatalogGroup> = {};

  for (const [groupKey, group] of Object.entries(walletBook.groups)) {
    groups[groupKey] = transformGroup({ group });
  }

  const wallets: Record<string, WalletConnectCatalogWallet> = {};

  for (const [walletKey, wallet] of Object.entries(walletBook.wallets)) {
    if (shouldFilterWallet(walletKey, wallet)) {
      continue;
    }

    wallets[walletKey] = transformWallet({ wallet, walletKey });
  }

  return { groups, wallets };
};
